export const formatDate = (isoString: string): string => {
  const date = new Date(isoString);

  const day = new Intl.DateTimeFormat("es-ES", { day: "numeric" }).format(date);
  const month = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(date);
  const year = new Intl.DateTimeFormat("es-ES", { year: "numeric" }).format(date);

  const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

  return `${day} de ${capitalizedMonth}, ${year}`;
};